import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EmpoweringEnterpriseEvolution from "./sections/EmpoweringEnterpriseEvolution";
import OurPromise from "./sections/OurPromise";
import ExpertCleaningSolutions from "./sections/ExpertCleaningSolutions";
import MaximizingYourEnergyOutput from "./sections/MaximizingYourEnergyOutput";
import ThePathToPeakPerformance from "./sections/ThePathToPeakPerformance";
import ReadyToScaleYourVision from "./sections/ReadyToScaleYourVision";
import InquiryPortal from "./sections/InquiryPortal";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EmpoweringEnterpriseEvolution />
      <OurPromise />
      <ExpertCleaningSolutions />
      <MaximizingYourEnergyOutput />
      <ThePathToPeakPerformance />
      <ReadyToScaleYourVision />
      <InquiryPortal />
      <FooterInformation />
    </div>;
}